import ActionTypes from "./types";

export default () => {
  return {
    type: ActionTypes.RESET_SEARCH_COMMENTS_RESULTS,
  };
};
